/**
 * Admin page — single merged Customer Mappings + Sync Health view.
 * Tabs were dropped when we folded SyncHealthDashboard into CustomerMappings.
 */
import React from 'react';
import CustomerMappings from './CustomerMappings';
import './Admin.css';

const Admin: React.FC = () => (
  <div className="admin-page">
    <CustomerMappings />
  </div>
);

export default Admin;
